import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import  Box from '@mui/material/Box';
import  Stack from '@mui/material/Stack';

import { unselectFeature } from 'handimap-react-lib/store/actions/selectedFeatureActions';
import { setContentType, setOpenSideBar } from 'handimap-react-lib/store/actions/sideBarActions';
import { SelectedSectionDetails } from 'handimap-react-lib/containers/SelectedDetails/SelectedSectionDetails';
import { SelectedGraphDetails } from 'handimap-react-lib/containers/SelectedDetails/SelectedGraphDetails';
import { CardInfoGraph } from 'handimap-react-lib/components/Card/CardInfoGraph';
import { unFocusElement } from 'handimap-react-lib/store/actions/focusActions';
import { SelectedFeatureDetails } from '../components/SelectedFeature/SelectedFeatureDetails';
import { BackButton } from '../components/BackButton';
import { SelectedTransportDetails } from '../components/SelectedTransportDetails';
import { SelectedObstacleDetails } from './SelectedObstacleDetails';

export const SelectedDetails = ({contentType, isMobile, status, feature, backSection}) => {
  const dispatch = useDispatch();

  const getFeatureInfoAttrs = useSelector(state => state.layerConf.getFeatureInfoAttrs);
  const lastFocused = useSelector(state => state.focus.focused);
  const elementFocused = useSelector(state => state.focus.elem);

  const goBack = async () => {
    dispatch(unselectFeature());
    dispatch(setOpenSideBar(false));
    if (lastFocused) {
      elementFocused.focus({focusVisible: true});
      dispatch(unFocusElement());
    }
    if (isMobile) {
      await new Promise(res => setTimeout(res, 50));
    }
    dispatch(setContentType(backSection));
  };

  useEffect(() => {
    if(status === 'loading') {
      goBack();
    } else {
      return;
    }
  }, [status]);

  const renderDetails = () => {
    if(contentType === 'selectedFeatureDetails') {
      return (
        <SelectedFeatureDetails 
          isMobile={isMobile} 
          layer_id={feature.layer.id}
          selectedFeature={feature}
          getFeatureInfoAttrs={getFeatureInfoAttrs}
        />
      );
    }
    if (contentType === 'selectedPathDetails') {
      return (
        <SelectedSectionDetails feature={feature} />
      );
    }
    if (contentType === 'selectedTransportDetails') {
      return (
        <SelectedTransportDetails
          isMobile={isMobile} 
          selectedTransport={feature} 
          status={status}
        />
      );
    }
    if (contentType === 'selectedGraphDetails') {
      return (
        <SelectedGraphDetails feature={feature} CardInfoGraph={CardInfoGraph}/>
      );
    }
    if (contentType === 'selectedObstacle') {
      return (
        <SelectedObstacleDetails feature={feature} />
      );
    }
  };

  const styles = {
    container: {
      display: 'flex',
      width: '100%',
      height: '100%',
    },
    headerContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      top:0,
      paddingY: '1em',
      paddingX: '.5em',
      zIndex:100
    },
    detailsContainer: {
      display: 'flex', 
      width: '100%',
      boxSizing: 'border-box'
    }
  };

  return (
    <Stack sx={styles.container} direction='column' spacing={3}>
      <Box sx={styles.headerContainer}>
        <BackButton returnCallback={goBack} />
      </Box>
      <Box sx={styles.detailsContainer}>
        {renderDetails()}
      </Box>
    </Stack>
  );
};  